import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import type { ReactNode } from 'react';

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));

const minWidth = 1100;
const GAP_AFTER_SIDEBAR = 24;
const FALLBACK_SIDEBAR_WIDTH = 100;
const RIGHT_PADDING = 24;
const LEFT_PADDING = `calc(var(--sidebar-width, ${FALLBACK_SIDEBAR_WIDTH}px) + ${GAP_AFTER_SIDEBAR}px)`;

interface CenteredGridProps {
  children?: ReactNode;
  fullHeigth?: boolean;
}

export const CenteredGrid = ({ children, fullHeigth }: CenteredGridProps) => {
  const classes = useStyles();
  return (
    <Grid style={{ flexGrow: 1, height: fullHeigth ? '100vh' : 'auto' }}>
      <Grid
        container
        style={{
          paddingRight: RIGHT_PADDING,
          paddingLeft: LEFT_PADDING,
          paddingTop: 30,
        }}
        classes={classes}
      >
        <Grid item style={{ minWidth }} xs={12} classes={classes}>
          {children}
        </Grid>
      </Grid>
    </Grid>
  );
};
